import React, { useEffect, useRef } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
export default function TheLegacyVision() {
  const videoRef = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.8;
    }
  }, []);
  return <section id="the-legacy-vision" className="relative h-screen min-h-[800px] w-full overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 z-0">
        <video ref={videoRef} autoPlay muted loop playsInline poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1552867/img/hero_skyline_poster.png" className="h-full w-full object-cover opacity-40 grayscale contrast-125 filter">
          {}
          <source src="https://cdn.pixabay.com/video/2020/05/25/40157-424930038_large.mp4" type="video/mp4" />
        </video>
        
        {}
        <div className="absolute inset-0 bg-primary/70" />
        
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-background" />
      </div>

      {}
      <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center sm:px-6 lg:px-8">
        <div className="max-w-4xl space-y-8 animate-in fade-in zoom-in-95 duration-1000 slide-in-from-bottom-4">
          <h1 className="font-serif text-5xl font-medium tracking-tight text-white sm:text-6xl md:text-7xl lg:text-[5rem] leading-[1.1]">
            The Legacy Vision
          </h1>
          
          <p className="mx-auto max-w-2xl font-sans text-lg text-white/90 sm:text-xl md:text-2xl font-light tracking-wide">
            Building solid foundations for a chosen, sovereign, and internationally aligned life.
          </p>

          <div className="pt-8">
            <Button asChild size="lg" className="relative h-14 min-w-[240px] overflow-hidden rounded-sm bg-accent px-8 text-lg font-medium text-accent-foreground shadow-[0_0_20px_rgba(199,176,138,0.3)] transition-all hover:bg-accent/90 hover:scale-105 hover:shadow-[0_0_30px_rgba(199,176,138,0.5)]">
              <Link to="#SuccessJurisdictions">Begin the Journey</Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-10 left-1/2 z-10 -translate-x-1/2 animate-bounce text-white/50">
        <div className="h-12 w-[1px] bg-gradient-to-b from-transparent to-white/50" />
      </div>
    </section>;
}